import { faker } from '@faker-js/faker';

export type UserLegacy = {
    code: string;
    name: string;
    legacyUserId: string;
};

function generateLegacyUser(): UserLegacy {
    return {
        code: faker.random.alphaNumeric(6).toUpperCase(),
        name: faker.name.findName(),
        legacyUserId: faker.datatype.uuid(),
    };
}

export function generateLegacyUsers(count: number): UserLegacy[] {
    return Array.from({ length: count }, generateLegacyUser);
}
